<template>
  <div class='container'>
    <el-row type="flex" justify="center" style="margin-top: 200px;">
      <el-col :xs="20" :sm="18" :md="14" :lg="8">
        <el-form :label-position="'left'" :model='registerResendForm' :rules="registerResendRules" ref="registerResendForm" label-width="80px"  >
          <el-row :gutter='0' style="text-align: center">
            <el-col><h2>重新发送注册验证邮件</h2></el-col>
          </el-row>
          <el-form-item label="邮件地址" prop="email">
            <el-input v-model="registerResendForm.email" placeholder="Email"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="submitForm('registerResendForm')">重新发送邮件</el-button>  
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'registerResendMailPage',
  data () {
    return {
      registerResendForm: {
        email: ''
      },
      registerResendRules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', required: true, message: '请输入可用的邮件地址', trigger: 'blur' },
          { max: 50, message: '您的用户名至多包含50个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      const vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          $.ajax({
            type: 'POST',
            url: '/v1/user/register/resendEmail',
            dataType: 'json',
            async: true,
            data: {
              email: vm.registerResendForm.email
            },
            success: function (data) {
              if (data.code === 200) {
                vm.$router.push('/user/register/resendPrompt?email=' + vm.registerResendForm.email)
              } else if (data.code === 200001) {
                vm.$message.error('未找到对应用户名')
              } else if (data.code === 200006) {
                vm.$message.error('账户已经激活过，不需要重复激活')
              }
            },
            error: function (XMLHttpRequest, textStatus) {
              if (textStatus === 'timeout') {
                vm.$message.error('响应超时，请稍后重试')
              } else {
                vm.$message.error('响应异常，请稍后重试')
              }
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
